import React from 'react';
import config from 'config';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useInfiniteQuery } from 'react-query';
import styles from './styles.scss';
import apiClient from '../../../helpers/apiClient';
import TableWrapper from '../../../components/TableWrapper/TableWrapper';

const cx = classNames.bind(styles);

async function getTransactions(task, status, { pageParam = null }) {
  return (
    await apiClient().get('/v1/deposit/history', {
      params: {
        asset: config.asset,
        count: 30,
        offset: pageParam,
        task,
        status,
      },
    })
  ).data;
}

export default function TransactionsTable({ task, status }) {
  const {
    data = { pages: [] }, fetchNextPage, hasNextPage, isFetching, isLoading,
  } = useInfiniteQuery(
    ['mytransactions', task, status],
    context => getTransactions(task, status, context),
    {
      getNextPageParam: lastGroup => {
        const lastElement = lastGroup[lastGroup.length - 1];
        return lastElement && lastElement.game_id;
      },
    }
  );

  const flatData = data.pages.flat();

  const columns = [{ label: 'Time' }, { label: 'Type' }, { label: 'Status' }, { label: 'Amount (BSV)' }];
  return (
    <TableWrapper
      isLoading={isLoading}
      columns={columns}
      className={cx('history-table')}
      infiniteScrollProps={{
        loadMore: () => fetchNextPage(),
        hasMore: !isFetching && hasNextPage,
      }}
      emptyPlaceholder={!flatData.length && 'You do not have any transactions'}
    >
      {flatData.map(({
        txid, status: txStatus, timestamp, amount, task: type,
      }) => {
        const date = new Date(timestamp);
        const dateString = date.toLocaleDateString('en-GB', {
          timeZone: 'UTC',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        });
        const timeString = date.toLocaleTimeString('en-GB', {
          timeZone: 'UTC',
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
        });

        return (
          <tr id={txid} className={cx('small')}>
            <td>{`${dateString} ${timeString}`}</td>
            <td>{type === 'DEPOSIT' ? 'Top-Up' : 'Cashout'}</td>
            <td>{txStatus[0] + txStatus.slice(1).toLowerCase()}</td>
            <td className={cx('bold', txStatus.toLowerCase())}>{amount}</td>
          </tr>
        );
      })}
    </TableWrapper>
  );
}
TransactionsTable.propTypes = {
  task: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};
